<h2 mat-dialog-title>{{ "sessionExpired.title" | translate }}</h2>
<div mat-dialog-content>
  <p>{{ "sessionExpired.message" | translate }}</p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="loginAgain()">
    {{ "sessionExpired.loginAgain" | translate }}
  </button>
</div>
